import type { ComponentPropsWithRef, ReactNode } from 'react';

import { cx } from '@/shared/lib/cx';

import styles from './size-option.module.scss';

export type SizeOptionProps = ComponentPropsWithRef<'button'> & {
  label: string;
  selected?: boolean;
  unavailable?: boolean;
  /** Small caption under the size ("рекомендуем", "нет в наличии"). */
  note?: ReactNode;
  highlighted?: boolean;
  size?: 'sm' | 'md';
};

/** Size choice. Unavailable sizes are struck through and stay focusable to show a tip. */
export function SizeOption({
  label,
  selected = false,
  unavailable = false,
  note,
  highlighted = false,
  size = 'md',
  className,
  type = 'button',
  ...props
}: SizeOptionProps) {
  return (
    <button
      {...props}
      type={type}
      className={cx(styles.root, className)}
      data-size={size}
      data-selected={selected || undefined}
      data-unavailable={unavailable || undefined}
      data-highlighted={highlighted || undefined}
      aria-pressed={selected}
      aria-disabled={unavailable || undefined}
      title={unavailable ? 'Нет в наличии' : undefined}
    >
      <span className={styles.label}>{label}</span>
      {note && <span className={styles.note}>{note}</span>}
    </button>
  );
}
